<div class="page-head-section">
  <p>Upcoming Events</p>
</div>

<div class="event-area">
  <div class="filters" style="margin-bottom: 30px">
   
  
    <div class="drop-area res-area">
      <p-dropdown
        placeholder="Filter by type"
        [options]="typeList"
        [(ngModel)]="typeFilter"
        (onChange)="filterByType($event)"
      ></p-dropdown>
    </div>
  
    <button (click)="ClearFilters()" class="clear-filter">Clear Filters</button>
  </div>
  
  <div class="events-row">
    <div class="event-card" *ngFor="let data of eventsData;  let i = index" [attr.data-index]="i">
      <div class="ui-g">
        <div class="ui-g-5 ui-lg-5 ui-sm-12 padZero">
          <div class="event-card-banner"  [style.backgroundImage]="'url(' + global?.basePathImage  + data?.banner + ')'"></div>
        </div>
        <div class="ui-g-7 ui-lg-7 ui-sm-12 padZero">
          <div class="event-wrap">
            <div class="event-flex">
              <img class="events-logo" [src]="global?.basePathImage + data?.photo" alt="" />
              <p class="event-title">
               {{data?.name}}
              </p>
            </div>
            <p class="event-description">
             {{data.description}}
            </p>
            <div class="min-flex" style="margin-top:30px">
            <p *ngIf="data?.dateTime!=='' && i==0" class="event-time" [id]="data._id"></p>
            
            <button (click)="newsDetails(data._id)" class="details-event">Event Details </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
